import { AdContextData } from "../type";

const TAGLESS_AD_PAGE_IDS = new Set([
    "citylab-culture"
]);

const AD_SERVICE_DV_TARGETING_PAGE_IDS = new Set(["citylab-technology", "phoenix-asia"]);

export const checkIfTaglessAdEnabled = (pageId: string) => TAGLESS_AD_PAGE_IDS.has(pageId);

export const isAdserviceDVTargetingEnabled = (pageId: string) => AD_SERVICE_DV_TARGETING_PAGE_IDS.has(pageId);

export const isInteractivePage = (adContextData: AdContextData) => adContextData.adPageType === "interactive";
export const isArticleDecoupled = (adContextData: AdContextData, isDecoupled: boolean) => isDecoupled && adContextData.adPageType === "article";
export const isQuoteDecoupled = (adContextData: AdContextData, isDecoupled: boolean) => isDecoupled && adContextData.adPageType === "quote";

export const isPersonalizedTargetingEnabled = (adContextData: AdContextData, isDecoupled: boolean) =>
    isArticleDecoupled(adContextData, isDecoupled) ||
    isInteractivePage(adContextData) || isQuoteDecoupled(adContextData, isDecoupled);
